import { memo } from 'react';

export default memo(SpinnerCircle);

function SpinnerCircle({
  color = 'currentColor',
  size = 24,
  className = '',
}: {
  color?: string;
  size?: number;
  className?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color }}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeOpacity="0.2"
        strokeWidth="3"
      />
      <path
        d="M12 2C13.576 2 15.1276 2.37146 16.5334 3.08426C17.9392 3.79707 19.1597 4.83087 20.0977 6.10456"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        className="animate-spin origin-center"
        style={{ transformOrigin: 'center' }}
      />
      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
      `}</style>
    </svg>
  );
}
